import { fontRootSize } from 'src/theme/adSales/fonts'
import { colors as defaultColors } from 'src/theme/adSales/colors'

import type { Theme } from 'theme-ui'

export const makeTheme = <T extends Theme>(t: T) => t

export const chunk = (arr: any[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_: any, i: number) =>
    arr.slice(i * size, i * size + size)
  )

export const pxToEm = (size: number, rootSize?: number) => `${size / (rootSize || fontRootSize)}em`

export const toPx = (size: number | string, rootSize?: number) =>
  `${(typeof size === 'string' ? parseFloat(size) : size) * (rootSize || fontRootSize)}px`

export const percentageToPx = (multiplier: number, size: number) =>
  `${Math.ceil(multiplier * (size / 100))}px`

export const toPxValue = (num: string) => Number(toPx(num).replace('px', ''))

export const hexToRgb = (hex: string) => {
  let hexChars = Array.from(hex.startsWith('#') ? hex.slice(1) : hex)
  if (hexChars.length === 3) {
    hexChars = hexChars.reduce((str, x) => [...str, x, x], [] as string[]) // 123 -> 112233
  }
  const values = chunk(hexChars, 2).map(([v1, v2]) => parseInt(v1 + v2, 16))
  return `${values.join(', ')}`
}

export const pxToRem = (size: number, rootSize?: number) =>
  `${size / (rootSize || fontRootSize)}rem`

export const gx = (from: string, to: string, colors?: any) => `radial-gradient(
    ellipse farthest-corner at top left,
    ${(colors || defaultColors)?.[from]},
    ${(colors || defaultColors)?.[to]}
  )`

export const util = {
  motion: '@media (prefers-reduced-motion: no-preference)',
  reduceMotion: '@media (prefers-reduced-motion: reduce)',
  reduceTransparency: '@media (prefers-reduced-transparency: reduce)',
  supportsClipText: '@supports (-webkit-background-clip: text)',
  supportsBackdrop: '@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none)'
}
